import { Autocomplete, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Autocomplete)`
  flex: 1;
  .MuiFormLabel-root {
    padding-left: ${(p) => p.theme.spacing(5)};
    color: ${(p) => p.theme.palette.primary[500]};
  }
  .MuiInputBase-root {
    color: ${(p) => p.theme.palette.primary[500]};
    background: ${(p) => p.theme.palette.common.white};
    padding-left: ${(p) => p.theme.spacing(5)};
  }
  label.Mui-focused {
    padding: 0;
  }
  .MuiFormLabel-filled {
    padding: 0;
  }
`;

export const Option = styled(MenuItem)`
  border: 1px solid ${(p) => p.theme.palette.primary[50]};
  margin: ${(p) => p.theme.spacing(1.5, 1)};
`;
